export enum AccountProfileStatus {
  PENDING = 'pending',
  REJECTED = 'rejected',
  VERIFIED = 'verified'
}

export enum AccountUsernameType {
  EMAIL = 'email',
  PHONE = 'phone'
}

export const BIRTH_DATE_FORMAT = 'DD/MM/YYYY';
export const SERVER_BIRTH_DATE_FORMAT = 'YYYY-MM-DD';



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/constants/account.ts